export function defaultMembersSortComparator(a = {}, b = {}) {
  const { studentGeneralInfo: studentAGeneralInfo = {} } = a;
  const { studentGeneralInfo: studentBGeneralInfo = {} } = b;

  const aFirstName = (studentAGeneralInfo.firstName || '').toLocaleLowerCase();
  const aLastName = (studentAGeneralInfo.lastName || '').toLocaleLowerCase();
  const bFirstName = (studentBGeneralInfo.firstName || '').toLocaleLowerCase();
  const bLastName = (studentBGeneralInfo.lastName || '').toLocaleLowerCase();

  if (a.isInProduction === b.isInProduction) {
    if (aFirstName === bFirstName) {
      return aLastName.localeCompare(bLastName);
    }
    return aFirstName.localeCompare(bFirstName);
  }

  if (a.isInProduction) {
    return - 1;
  }

  return 1;
}

export default defaultMembersSortComparator;



// WEBPACK FOOTER //
// ./data/GroupMembers/sort.js